export default "__VITE_ASSET__9oI9SYxe__"